<template>
	<section class="page-reset">
		
		<PageHeader title="Reset password" />

		<form class="reset-form" @submit.prevent="resetPass">
			
			<div class="form-group">
				<label>Password</label>
				<input
					type="password"
					class="form-control"
					name="password"
					placeholder="Password"
					v-model="password"
					:class="{ 'is-invalid': isInvalid }"
				/>
			</div>

			<div class="form-group">
				<label>Confirm password</label>
				<input
					type="password"
					class="form-control"
					name="confirm"
					placeholder="Confirm Password"
					v-model="confirm"
					:class="{ 'is-invalid': isInvalid }"
				/>
			</div>

			<div class="form-group mt-5">
				<button class="btn btn-primary w-100" type="submit">
					<span
						v-if="loading"
						class="spinner-border spinner-border-sm mr-2"
						role="status"
						aria-hidden="true"
					></span>
					Reset password
				</button>
			</div>

			<div class="form-group mt-3">
				<router-link
					class="btn btn-secondary w-100"
					type="submit"
					:to="{ path: '/console/login' }"
					>Back to login</router-link
				>
			</div>

			<ErrorDialog ref="errDialog" />
		</form>
	</section>
</template>

<script>
import PageHeader from "../shared/PageHeader";
import Register from "../../services/register";
import ErrorDialog from "../shared/ErrorDialog";

export default {
	name: "Reset",
	components: {
		PageHeader,
		ErrorDialog,
	},
	data() {
		return {
			password: "",
			confirm: "",
			loading: false,
			isInvalid: false,
		};
	},
	methods: {
		resetPass() {
			if (this.password != this.confirm) {
				this.isInvalid = true;
				return;
			}
			this.isInvalid = false;
			this.loading = true;
			let token = this.$route.query.token;
			Register.instance()
				.resetPassword(this.password, token)
				.then(() => {
					this.loading = false;
					this.$router.push({ path: "/console/reset/success" });
				})
				.catch((err) => {
					this.loading = false;
					this.$refs.errDialog.show(err);
				});
		},
	},
};
</script>